export default __webpack_public_path__ + "static/media/iconInstitutionEmptyFill.4b185f51.svg";